import { FeatureSection } from "./types";

export const data: FeatureSection[] = [
	{
		heading: "Navigation",
		content: <>
			<p>The navigation app, specific to your operating system, serves as the foundation for Honda RoadSync. Turn-by-turn directions are provided exclusively through voice guidance and displayed as static symbols on the meter panel. You can store five preset favourite places and save local destinations or points of interest. Additionally, the TFT models offer a convenient voice search feature for quickly acquiring addresses while on the move.</p>
			<p><em>*Currently, Honda Road Sync is only available for the Hornet and Transalp motorcycles in South Africa.</em></p>
		</>,
		image: "/roadsync/features/feature-1.jpg"
	},
	{
		heading: "Weather",
		content: <>
			<p>There’s also the option to check the day’s local weather forecast within an hour, 2 hours or 5 hours ahead. When using Navigation, it’s also possible to check a detailed forecast for your destination.</p>
		</>,
		image: "/roadsync/features/feature-2.jpg"
	},
	{
		heading: "Calls",
		content: <>
			<p>You can store up to 5 frequent contacts for rapid call connection. Additionally, there’s a voice search option (TFT models only); simply say the name of the person you want to speak to, and Honda RoadSync does the rest. For incoming calls, the system announces who’s calling, allowing you to decide whether to accept or decline.</p>
		</>,
		image: "/roadsync/features/feature-3.jpg"
	},
	{
		heading: "Messages",
		content: <>
			<p>There are 5 default Quick Messages stored, which can be replaced with your own personalised ones. You can also use voice search to find a contact and then input an SMS message to be sent in text form. Incoming messages are converted to voice feedback for easy listening. Additionally, other supported messaging apps, such as WhatsApp, Facebook Messenger, and LINE, allow you to read and reply by voice.</p>
		</>,
		image: "/roadsync/features/feature-4.jpg"
	},
	{
		heading: "Music",
		content: <>
			<p>It’s easy to stream the perfect soundtrack to your day. Pre-select a favourite music app (iOS only compatible with Apple Music) in Honda RoadSync settings before leaving, select your music and go.</p>
		</>,
		image: "/roadsync/features/feature-5.jpg"
	},
	{
		heading: "Volume",
		content: <>
			<p>To adjust playback level, simply select Volume in Honda RoadSync and push the 4-way toggle up for louder, down for quieter.</p>
		</>,
		image: "/roadsync/features/feature-6.jpg"
	},
]
